import { PlayerMetricHeuristic } from '../../../jscaip/AI/PlayerMetricHeuristic';
import { PlayerNumberTable } from '../../../jscaip/PlayerNumberTable';
export class ReversiHeuristic extends PlayerMetricHeuristic {
    getMetrics(node, _config) {
        const state = node.gameState;
        const metrics = PlayerNumberTable.of([0], [0]);
        for (const coordAndContent of state.getPlayerCoordsAndContent()) {
            const coord = coordAndContent.coord;
            const player = coordAndContent.content;
            const verticalBorder = state.isVerticalEdge(coord);
            const horizontalBorder = state.isHorizontalEdge(coord);
            const locationValue = (verticalBorder ? 4 : 1) * (horizontalBorder ? 4 : 1);
            metrics.add(player, 0, locationValue);
        }
        return metrics;
    }
}
